export enum WorkshopIntensityEnum {
  LOW = "Low ",
  MEDIUM = "Medium",
  HARD = "High",
}
